import { render, staticRenderFns } from "./AccountControl.vue?vue&type=template&id=288b9764&scoped=true&"
import script from "./AccountControl.vue?vue&type=script&lang=js&"
export * from "./AccountControl.vue?vue&type=script&lang=js&"
import style0 from "./AccountControl.vue?vue&type=style&index=0&id=288b9764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b9764",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCardText,VContainer,VIcon,VTab,VTabItem,VTabs,VTabsItems})
